export function tableHeaders() {
  var propType = $("#propertyTypeSelector").val();
  if (!propType) {
    propType = $("#search_fields_PropertyType_value").val();
    if (!propType) {
      propType = 'A'
    }
  }

  const propTypeSelectorEnabled = $("#search_fieldsPropertyType-checkbox").prop("checked");

    var tableHeader = $("#listingsDataTable thead tr");
    if (tableHeader.length > 0) {
      // No need to make this call if the table header is not on the page (list vs summary)
      let viewId = getViewId();

      if(viewId){
        let url = ""

        if (propTypeSelectorEnabled == true) {
          url = getViewsRelativePath() + viewId + '?property_type=' + propType;
        } else {
        
          let proptTypeFromMapSupport = "";
          if (window.mapSupport?.parsedFilter.length) {
            for (let filter of window.mapSupport.parsedFilter) {
              if (filter.field == "PropertyType") {
                proptTypeFromMapSupport = filter.condition.split(',').map(string => string.replace(/'/g, ''));
                break
              }
            }
          }
          
          if (proptTypeFromMapSupport.length) {
            url = getViewsRelativePath() + viewId + '?property_type=' + proptTypeFromMapSupport;
          } else {
            url = getViewsRelativePath() + viewId;
          }
        }

        $.ajax({
          url: url,
          dataType: 'json',
          success: function(d){
            tableHeader.find('th:not(.preserve)').remove(); // MLS #, Status, and Price are always preserved in the table
            $(d.headers).each(function(i,tableTitle){
              let label = tableTitle.label;
              let id = `th-${tableTitle.id}`;
              let index = i + 4;
              tableHeader.append('<th id=' + id + ' data-resizable-table-target="resizableHeader" data-column-index="' + index + '" >' + label + '</th>');
            });

            let customColumnWidths = d.customColumnWidths;

            if (!window.customColumnWidths) {
              window.customColumnWidths = customColumnWidths || {};
            } else {
              window.customColumnWidths = {...window.customColumnWidths, ...customColumnWidths};
            }
            refreshTableController()
          },
          error: function(e){
            console.log('error' + JSON.stringify(e))
          }
        })
      }
    } 
  }

  // Function to refresh the Stimulus controller
  function refreshTableController() {
    const tableContainer = document.querySelector('[data-controller*="resizable-table"]');

    if (tableContainer) {
      // Make sure window.Stimulus is defined by the time this code runs.
      const stimulusApp = window.Stimulus;

      if (stimulusApp) {
          const controllerInstance = stimulusApp.getControllerForElementAndIdentifier(tableContainer, "resizable-table");
          if (controllerInstance) {
              controllerInstance.refresh();
          }
      }
    }
  }

export function getViewsRelativePath() {
  // If you are on the listings page and call ajax with url = 'views/'  all is well.  Ajax is using a path relative to the current path.
  // But if you are on one of the sub pages viewing an ldp (listings/id), then the ajax url will take you to listings/view.  NOT A VALID PATH.
  // Or if you are in a listing report (listings/id/history), it will take you to listings/id/view.  Also NOT A VALID PATH.
  // Since the search results need the views no matter how many modal layers in you are, we still need to point to the relative views path.
  // So add a ../ to the url for each path segment beyond listings.  (And we cannot get here without the listings segment so we know it is there.)
  let url = 'views/';
  const pathSegments = window.location.pathname.split('/').filter(segment => segment !== '');
  let subDirectoryCount = 0;

  // Loop backwards through the segments
  for (let i = pathSegments.length - 1; i >= 0; i--) {
    if (pathSegments[i] !== 'listings') {
        subDirectoryCount++;
    } else {
        break;
    }
  }

  url = '../'.repeat(subDirectoryCount) + url;
  return url;
}

export function getViewId() {
  let selectorControl = $('.selected-view');
  let viewId = null;
  if (selectorControl.length > 0)
    viewId = selectorControl.attr('data-view-id');
  else {
    let defaultViewAttrHolder = $('[data-default-view-id]')
    if (defaultViewAttrHolder.length > 0) {
      viewId = defaultViewAttrHolder.attr('data-default-view-id')
    }
  }

  return viewId;
}